import React, { useState, useEffect } from "react";
import dynadotLogo from "../asset/dynadot.png";
import godaddyIcon from "../asset/godaddy.svg";
import { apiBaseUrl } from "../utils";

function logClick(domain, url, section) {
  fetch(`${apiBaseUrl}/api/log-click`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ domain, url, section }),
  }).catch(() => {});
}

const PRICE_SCHEDULES = {
  batch1: {
    firstDropNoonUtc: Date.UTC(2026, 3, 15, 12, 0, 0), // April 15, 2026 12:00 GMT
    prices: [999, 888, 777, 666, 599, 499, 399, 299],
  },
  batch2: {
    firstDropNoonUtc: Date.UTC(2026, 3, 23, 12, 0, 0), // April 23, 2026 12:00 GMT
    prices: [999, 888, 777, 777, 666, 599, 499, 399, 299], // 777 held for extra day (Apr 25)
  },
  batch3: {
    firstDropNoonUtc: Date.UTC(2026, 3, 29, 12, 0, 0), // April 29, 2026 12:00 GMT
    prices: [999, 888, 777, 666, 599, 499, 399, 299],
  },
  batch4: {
    firstDropNoonUtc: Date.UTC(2026, 4, 13, 12, 0, 0), // May 13, 2026 12:00 GMT
    prices: [999, 899, 799, 699, 599, 499, 399, 299],
  },
  batch4main: {
    firstDropNoonUtc: Date.UTC(2026, 4, 13, 12, 0, 0), // May 13, 2026 12:00 GMT
    prices: [5000, 4500, 4000, 3500, 3000, 2500, 2000, 1500, 999, 799, 599, 499, 399, 299],
  },
  batch4uk: {
    firstDropNoonUtc: Date.UTC(2026, 4, 13, 12, 0, 0), // May 13, 2026 12:00 GMT
    prices: [1999, 1799, 1599, 1399, 1199, 999, 799, 599, 499, 399, 299],
  },
  batch6old: {
    firstDropNoonUtc: Date.UTC(2026, 4, 29, 12, 0, 0), // May 29, 2026 12:00 GMT
    prices: [1999, 1888, 1777, 1666, 1555, 1444, 1333, 1222, 1111, 999],
  },
  batchGXU: {
    firstDropNoonUtc: Date.UTC(2026, 4, 29, 12, 0, 0), // May 29, 2026 12:00 GMT
    prices: [19999, 19888, 19777, 19666, 19555, 19444, 19333, 19222, 19111, 19000],
  },
  batch5: {
    firstDropNoonUtc: Date.UTC(2026, 4, 20, 12, 0, 0), // May 20, 2026 12:00 GMT
    prices: [999, 899, 799, 699, 599, 499, 399, 299],
  },
  batch7: {
    firstDropNoonUtc: Date.UTC(2026, 4, 27, 12, 0, 0), // May 27, 2026 12:00 GMT
    prices: [999, 899, 799, 699, 599, 499, 399, 299],
  },
  batch8: {
    firstDropNoonUtc: Date.UTC(2026, 5, 3, 12, 0, 0), // June 3, 2026 12:00 GMT
    prices: [999, 899, 799, 699, 599, 499, 399, 299],
  },
  batchIncrease: {
    firstDropNoonUtc: Date.UTC(2026, 5, 11, 12, 0, 0), // June 11, 2026 12:00 GMT
    prices: [999, 1099, 1199, 1299, 1399, 1499, 1599, 1699, 1799, 1899, 1999, 2099, 2199, 2299, 2399, 2499, 2599, 2699, 2799, 2899, 2999, 3099, 3199, 3299, 3399, 3499, 3599, 3699, 3799, 3899, 3999, 4099, 4199, 4299, 4399, 4499, 4599, 4699, 4799, 4899, 4999, 5000],
  },
  batch9: {
    firstDropNoonUtc: Date.UTC(2026, 5, 11, 12, 0, 0), // June 11, 2026 12:00 GMT
    prices: [1399, 1299, 1199, 1099, 999, 899, 799, 699, 599, 499],
  },
  batchGXUIncrease: {
    firstDropNoonUtc: Date.UTC(2026, 5, 13, 12, 0, 0), // June 13, 2026 12:00 GMT
    prices: [20000, 20100, 20200, 20300, 20400, 20500, 20600, 20700, 20800, 20900, 21000, 21100, 21200, 21300, 21400, 21500, 21600, 21700, 21800, 21900, 22000, 22100, 22200, 22300, 22400, 22500, 22600, 22700, 22800, 22900, 23000, 23100, 23200, 23300, 23400, 23500, 23600, 23700, 23800, 23900, 24000, 24100, 24200, 24300, 24400, 24500, 24600, 24700, 24800, 24900, 25000],
  },
  batch10: {
    firstDropNoonUtc: Date.UTC(2026, 7, 10, 12, 0, 0), // August 10, 2026 12:00 GMT
    prices: [999, 899, 799, 699, 599, 499, 399, 299],
  },
};

function getSchedulePrice(schedule) {
  const nowUtc = Date.now();
  const msSinceFirstDrop = nowUtc - schedule.firstDropNoonUtc;
  if (msSinceFirstDrop < 0) return schedule.prices[0];
  const dropsPassed = Math.floor(msSinceFirstDrop / (24 * 60 * 60 * 1000)) + 1;
  const idx = Math.min(dropsPassed, schedule.prices.length - 1);
  return schedule.prices[idx];
}

function getCurrentPrice(batch) {
  const schedule = PRICE_SCHEDULES[batch || "batch1"];
  return getSchedulePrice(schedule);
}

function getNextPriceChangeDate(batch) {
  const schedule = PRICE_SCHEDULES[batch || "batch1"];
  const nowUtc = Date.now();
  const dayMs = 24 * 60 * 60 * 1000;
  const currentPrice = getSchedulePrice(schedule);

  // If already at the last price, no more changes
  if (currentPrice === schedule.prices[schedule.prices.length - 1]) return null;

  // Find the next noon GMT where the price differs
  const msSinceFirstDrop = nowUtc - schedule.firstDropNoonUtc;
  const currentSlot = msSinceFirstDrop < 0 ? -1 : Math.floor(msSinceFirstDrop / dayMs);

  for (let i = currentSlot + 1; i < schedule.prices.length; i++) {
    const slotPrice = schedule.prices[Math.min(i + 1, schedule.prices.length - 1)];
    if (slotPrice !== currentPrice) {
      const changeTime = new Date(schedule.firstDropNoonUtc + i * dayMs);
      const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
      return `${months[changeTime.getUTCMonth()]} ${changeTime.getUTCDate()}`;
    }
  }
  return null;
}

const WEEK_START = Date.UTC(2026, 8, 15, 0, 0, 0); // Sep 15, 2026 0:00 GMT

function getDecayPrice(startPrice) {
  const now = Date.now();
  if (now < WEEK_START) return startPrice;
  const daysPassed = Math.floor((now - WEEK_START) / (24 * 60 * 60 * 1000));
  return Math.round(startPrice * Math.pow(0.9, daysPassed));
}

// ── This Week — $398 Handpicked Domains ──
const thisWeekDomains = [
  { domain: "QLV.si", details: "SI = Super Intelligence, the hottest extension right now!", type: "fixed", price: 398, localPurchase: true, currency: "US$" },
  { domain: "MQQJ.com", details: "registered 2022, DotDB: 4, Estibot: $3,600", makeOffer: true, minBid: 398, labelOverride: "Min. bid $398", currency: "US$" },
  { domain: "EmailMinistry.com", details: "registered 2000, Dynadot: $6,486", type: "fixed", price: 398, localPurchase: true, currency: "US$" },
  { domain: "Cam100.com", details: "registered 2017, DotDB: 4, Dynadot: $2,472", type: "fixed", price: 398, localPurchase: true, currency: "US$" },
  { domain: "TeleWhip.com", details: "registered 2018, Dynadot: $10,483", type: "fixed", price: 398, localPurchase: true, currency: "US$" },
  { domain: "ModEmail.com", details: "registered 2004, DotDB: 3, Dynadot: $9,446", type: "fixed", price: 398, localPurchase: true, currency: "US$" },
  { domain: "PrivateClientArea.com", details: "registered 2001, GoDaddy Value: $1,280", type: "fixed", price: 398, localPurchase: true, currency: "US$" },
  { domain: "DZJ.cc", details: "registered 2013, DotDB: 36", type: "fixed", price: 398, localPurchase: true, currency: "US$" },
  { domain: "TrademarkConnection.com", details: "registered 2003, Dynadot: $1,906", type: "fixed", price: 398, localPurchase: true, currency: "US$" },
  { domain: "VehicleHandbook.com", details: "registered 2016, Dynadot: $5,342", type: "fixed", price: 398, localPurchase: true, currency: "US$" },
  { domain: "MarijuanaCentre.com", details: "registered 2010, GoDaddy Value: $4,448", type: "fixed", price: 398, localPurchase: true, currency: "US$" },
];

// ── (unused) ──
const deDomains = [];

// ── Past Week — SI Domains ──
const pastWeekSiDomains = [
  { domain: "Criticism.si", displayName: "Criticism.si + Criticism.ai", details: "unique bundle", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/criticism.si" },
  { domain: "XSIIW.com", details: "", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/xsiiw.com" },
  { domain: "RCF.si", details: "Estibot: $1,400", type: "fixed", price: 500, currency: "US$", url: "https://forsale.godaddy.com/forsale/rcf.si" },
  { domain: "IGH.si", details: "", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/igh.si" },
  { domain: "IEF.si", details: "", labelOverride: "Dynadot Auction", type: "auction", currency: "US$", url: "https://www.dynadot.com/market/user-auction/ief.si" },
  { domain: "GFF.si", details: "", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/gff.si" },
  { domain: "58.si", details: "", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/58.si" },
  { domain: "Apologize.si", details: "", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/apologize.si" },
  { domain: "Improved.si", details: "", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/improved.si" },
  { domain: "Clearer.si", details: "", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/clearer.si" },
  { domain: "XXXXX.si", details: "", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/xxxxx.si" },
];

// ── Past Week — Deutsche SI Domains ──
const lastWeekGermanDomains = [
  { domain: "GRSI.de", details: "", makeOffer: true, currency: "€", url: "https://forsale.godaddy.com/forsale/grsi.de" },
  { domain: "IJSI.de", details: "", makeOffer: true, currency: "€", url: "https://forsale.godaddy.com/forsale/ijsi.de" },
  { domain: "Arbeit.si", details: "", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/arbeit.si" },
  { domain: "Frei.si", details: "", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/frei.si" },
  { domain: "Sicher.si", details: "", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/sicher.si" },
  { domain: "Kurse.si", details: "", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/kurse.si" },
  { domain: "Akademie.si", details: "", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/akademie.si" },
  { domain: "Lernen.si", details: "", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/lernen.si" },
  { domain: "Bilder.si", details: "", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/bilder.si" },
  { domain: "Kunden.si", details: "", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/kunden.si" },
];

// ── Past Week — Private Offers ──
const lastWeekDomains = [
  { domain: "Mgkk.com", details: "registered 1995, DotDB: 11, Estibot: $40,000", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/mgkk.com" },
  { domain: "Incentives.net", details: "registered 1997, DotDB: 101, Estibot: $12,000", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/incentives.net" },
  { domain: "Distance.org", details: "registered 1997, DotDB: 137, Estibot: $18,000", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/distance.org" },
  { domain: "Concerns.org", details: "registered 1997, DotDB: 27, Dynadot: $6,330", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/concerns.org" },
  { domain: "Upset.org", details: "registered 1998, DotDB: 65, Dynadot: $5,843", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/upset.org" },
  { domain: "Confessions.org", details: "registered 1998, DotDB: 73, Estibot: $11,000", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/confessions.org" },
  { domain: "Gerunds.com", details: "registered 1998, DotDB: 2, Dynadot: $23,127", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/gerunds.com" },
  { domain: "AvailableBooks.com", details: "registered 1999, DotDB: 1, Dynadot: $2,616", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/availablebooks.com" },
  { domain: "OneApril.com", details: "registered 1999, DotDB: 4, Dynadot: $3,881", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/oneapril.com" },
  { domain: "Bwz.net", details: "registered 2000, Dynadot: $6,071", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/bwz.net" },
  { domain: "Tvj.net", details: "registered 2000, DotDB: 57, Estibot: $18,000", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/tvj.net" },
  { domain: "Aad.cc", details: "registered 2000, DotDB: 140", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/aad.cc" },
  { domain: "ToiletLease.com", details: "registered 2000, DotDB: 1, Dynadot: $9,002", makeOffer: true, currency: "US$", url: "https://forsale.godaddy.com/forsale/toiletlease.com" },
];

const lastWeekUkDomains = [];

const BottomReachedBadge = () => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "5px",
      padding: "5px 14px",
      borderRadius: "50px",
      background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
      color: "#000",
      fontWeight: 700,
      fontSize: "11px",
      letterSpacing: "0.04em",
      textTransform: "uppercase",
      whiteSpace: "nowrap",
      boxShadow: "0 2px 8px rgba(245,158,11,0.25)",
    }}
  >
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
    Bottom reached
  </span>
);

const BidNowButton = ({ onClick }) => (
  <button
    onClick={onClick}
    className="dynadot-buy-btn"
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      padding: "10px 28px",
      borderRadius: "50px",
      background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
      color: "#fff",
      fontWeight: 700,
      fontSize: "13px",
      letterSpacing: "0.05em",
      textTransform: "uppercase",
      border: "none",
      cursor: "pointer",
      boxShadow: "0 2px 12px rgba(59,130,246,0.35), inset 0 1px 0 rgba(255,255,255,0.2)",
      transition: "all 0.2s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-1px)";
      e.currentTarget.style.boxShadow = "0 6px 24px rgba(59,130,246,0.5), inset 0 1px 0 rgba(255,255,255,0.2)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "0 2px 12px rgba(59,130,246,0.35), inset 0 1px 0 rgba(255,255,255,0.2)";
    }}
  >
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L2 7l10 5 10-5-10-5z" />
      <path d="M2 17l10 5 10-5" />
      <path d="M2 12l10 5 10-5" />
    </svg>
    Bid Now
  </button>
);

const BidForm = ({ domain, minBid, currency, onClose, onBidPlaced }) => {
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [bidAmount, setBidAmount] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [effectiveMin, setEffectiveMin] = useState(minBid);

  useEffect(() => {
    fetch(`${apiBaseUrl}/api/max-bids`).then(r => r.json()).then(data => {
      const highest = data[domain.toLowerCase()] || 0;
      const computed = highest > 0 ? highest + 10 : minBid;
      setEffectiveMin(Math.max(minBid, computed));
    }).catch(() => {});
  }, [domain, minBid]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email && !mobile) { setError("Please enter an email or mobile number"); return; }
    if (!bidAmount || parseFloat(bidAmount) < effectiveMin) { setError(`Minimum bid is ${currency}${effectiveMin}`); return; }
    setError("");
    fetch(`${apiBaseUrl}/api/place-bid`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ domain, email, mobile, bidAmount }),
    })
    .then((res) => {
      if (res.ok) { setSubmitted(true); if (onBidPlaced) onBidPlaced(); }
      else setError("Error placing bid");
    })
    .catch(() => setError("Error placing bid"));
  };

  return (
    <div
      onClick={onClose}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 10000 }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#1a1a1a",
          border: "1px solid rgba(139,92,246,0.3)",
          borderRadius: "20px",
          padding: "32px",
          maxWidth: "420px",
          width: "90%",
          fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
        }}
      >
        <h3 style={{ color: "#fff", fontSize: "1.2rem", fontWeight: 700, marginBottom: "4px" }}>Place a Bid</h3>
        <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.9rem", marginBottom: "20px" }}>{domain}</p>
        {submitted ? (
          <p style={{ color: "#8b5cf6", fontSize: "14px", textAlign: "center", padding: "20px 0" }}>Bid submitted successfully!</p>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
              style={{ background: "#111", border: "1px solid #333", borderRadius: "12px", padding: "10px 16px", color: "#fff", fontSize: "14px", outline: "none" }} />
            <input type="tel" placeholder="Mobile" value={mobile} onChange={(e) => setMobile(e.target.value)}
              style={{ background: "#111", border: "1px solid #333", borderRadius: "12px", padding: "10px 16px", color: "#fff", fontSize: "14px", outline: "none" }} />
            <p style={{ color: "rgba(255,255,255,0.35)", fontSize: "11px", margin: 0 }}>Email or mobile required</p>
            <input type="number" placeholder={`Min. ${currency}${effectiveMin}`} min={effectiveMin} value={bidAmount} onChange={(e) => setBidAmount(e.target.value)}
              style={{ background: "#111", border: "1px solid #333", borderRadius: "12px", padding: "10px 16px", color: "#fff", fontSize: "14px", outline: "none" }} />
            <p style={{ color: "rgba(255,255,255,0.35)", fontSize: "11px", margin: 0 }}>Your bid ({currency}). All bids are private. Minimum: {currency}{effectiveMin}</p>
            {error && <p style={{ color: "#ef4444", fontSize: "12px", margin: 0 }}>{error}</p>}
            <div style={{ display: "flex", gap: "10px", marginTop: "4px" }}>
              <button type="submit" style={{
                flex: 1, background: "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)", color: "#fff", fontWeight: 700,
                fontSize: "14px", padding: "10px", borderRadius: "12px", border: "none", cursor: "pointer",
              }}>Place Bid</button>
              <button type="button" onClick={onClose} style={{
                flex: 1, background: "transparent", color: "rgba(255,255,255,0.5)", fontWeight: 600,
                fontSize: "14px", padding: "10px", borderRadius: "12px", border: "1px solid #333", cursor: "pointer",
              }}>Cancel</button>
            </div>
            <p style={{ color: "rgba(255,255,255,0.3)", fontSize: "10px", margin: 0, textAlign: "center" }}>This is a binding bid.</p>
          </form>
        )}
      </div>
    </div>
  );
};

const PurchaseForm = ({ domain, price, currency, onClose }) => {
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const coupon = "";
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email && !mobile) { setError("Please enter an email or mobile number"); return; }
    setError("");
    fetch(`${apiBaseUrl}/api/purchase`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ domain, email, mobile, coupon }),
    })
    .then((res) => {
      if (res.ok) setSubmitted(true);
      else setError("Error submitting purchase");
    })
    .catch(() => setError("Error submitting purchase"));
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 10000 }}>
      <div onClick={(e) => e.stopPropagation()} style={{
        background: "#1a1a1a", border: "1px solid rgba(31,226,165,0.3)", borderRadius: "20px",
        padding: "32px", maxWidth: "420px", width: "90%", fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
      }}>
        <h3 style={{ color: "#fff", fontSize: "1.2rem", fontWeight: 700, marginBottom: "4px" }}>Buy Now</h3>
        <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.9rem", marginBottom: "4px" }}>{domain}</p>
        <p style={{ color: "#1FE2A5", fontSize: "1.1rem", fontWeight: 700, marginBottom: "20px" }}>{currency}{price}</p>
        {submitted ? (
          <p style={{ color: "#1FE2A5", fontSize: "14px", textAlign: "center", padding: "20px 0" }}>Purchase request submitted! We'll be in touch.</p>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
              style={{ background: "#111", border: "1px solid #333", borderRadius: "12px", padding: "10px 16px", color: "#fff", fontSize: "14px", outline: "none" }} />
            <input type="tel" placeholder="Mobile" value={mobile} onChange={(e) => setMobile(e.target.value)}
              style={{ background: "#111", border: "1px solid #333", borderRadius: "12px", padding: "10px 16px", color: "#fff", fontSize: "14px", outline: "none" }} />
            <p style={{ color: "rgba(255,255,255,0.35)", fontSize: "11px", margin: 0 }}>Email or mobile required</p>
            {error && <p style={{ color: "#ef4444", fontSize: "12px", margin: 0 }}>{error}</p>}
            <div style={{ display: "flex", gap: "10px", marginTop: "4px" }}>
              <button type="submit" style={{
                flex: 1, background: "linear-gradient(135deg, #1FE2A5 0%, #14b882 100%)", color: "#000", fontWeight: 700,
                fontSize: "14px", padding: "10px", borderRadius: "12px", border: "none", cursor: "pointer",
              }}>Confirm Purchase</button>
              <button type="button" onClick={onClose} style={{
                flex: 1, background: "transparent", color: "rgba(255,255,255,0.5)", fontWeight: 600,
                fontSize: "14px", padding: "10px", borderRadius: "12px", border: "1px solid #333", cursor: "pointer",
              }}>Cancel</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

const MessageForm = ({ domain, onClose }) => {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email && !phone) { setError("Please enter an email or phone number"); return; }
    setError("");
    fetch(`${apiBaseUrl}/api/message`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ domain, email, phone, message }),
    })
    .then((res) => { if (res.ok) setSubmitted(true); else setError("Error sending message"); })
    .catch(() => setError("Error sending message"));
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 10000 }}>
      <div onClick={(e) => e.stopPropagation()} style={{
        background: "#1a1a1a", border: "1px solid rgba(31,226,165,0.3)", borderRadius: "20px",
        padding: "32px", maxWidth: "440px", width: "90%", fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
      }}>
        <h3 style={{ color: "#fff", fontSize: "1.2rem", fontWeight: 700, marginBottom: "4px" }}>Message about {domain}</h3>
        <p style={{ color: "#1FE2A5", fontSize: "0.8rem", lineHeight: 1.5, marginBottom: "20px", background: "rgba(31,226,165,0.08)", padding: "10px 14px", borderRadius: "10px", border: "1px solid rgba(31,226,165,0.15)" }}>
          If the pending sale does not complete, we will reach out to the next interested party.
        </p>
        {submitted ? (
          <p style={{ color: "#1FE2A5", fontSize: "14px", textAlign: "center", padding: "20px 0" }}>Message sent! We'll be in touch.</p>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
              style={{ background: "#111", border: "1px solid #333", borderRadius: "12px", padding: "10px 16px", color: "#fff", fontSize: "14px", outline: "none" }} />
            <input type="tel" placeholder="Phone" value={phone} onChange={(e) => setPhone(e.target.value)}
              style={{ background: "#111", border: "1px solid #333", borderRadius: "12px", padding: "10px 16px", color: "#fff", fontSize: "14px", outline: "none" }} />
            <p style={{ color: "rgba(255,255,255,0.35)", fontSize: "11px", margin: 0 }}>Email or phone required</p>
            <textarea placeholder="Your message (optional)" value={message} onChange={(e) => setMessage(e.target.value)} rows={3}
              style={{ background: "#111", border: "1px solid #333", borderRadius: "12px", padding: "10px 16px", color: "#fff", fontSize: "14px", outline: "none", resize: "vertical" }} />
            {error && <p style={{ color: "#ef4444", fontSize: "12px", margin: 0 }}>{error}</p>}
            <div style={{ display: "flex", gap: "10px", marginTop: "4px" }}>
              <button type="submit" style={{
                flex: 1, background: "linear-gradient(135deg, #1FE2A5 0%, #14b882 100%)", color: "#000", fontWeight: 700,
                fontSize: "14px", padding: "10px", borderRadius: "12px", border: "none", cursor: "pointer",
              }}>Send</button>
              <button type="button" onClick={onClose} style={{
                flex: 1, background: "transparent", color: "rgba(255,255,255,0.5)", fontWeight: 600,
                fontSize: "14px", padding: "10px", borderRadius: "12px", border: "1px solid #333", cursor: "pointer",
              }}>Cancel</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

const BuyNowButton = ({ href, onClick, label }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    onClick={onClick}
    className="dynadot-buy-btn"
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      padding: "10px 28px",
      borderRadius: "50px",
      background: "linear-gradient(135deg, #1FE2A5 0%, #14b882 50%, #0fa36e 100%)",
      color: "#000",
      fontWeight: 700,
      fontSize: "13px",
      letterSpacing: "0.05em",
      textTransform: "uppercase",
      textDecoration: "none",
      border: "none",
      cursor: "pointer",
      boxShadow: "0 2px 12px rgba(31,226,165,0.25), inset 0 1px 0 rgba(255,255,255,0.2)",
      transition: "all 0.2s ease",
      whiteSpace: "nowrap",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-1px)";
      e.currentTarget.style.boxShadow = "0 6px 24px rgba(31,226,165,0.4), inset 0 1px 0 rgba(255,255,255,0.2)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "0 2px 12px rgba(31,226,165,0.25), inset 0 1px 0 rgba(255,255,255,0.2)";
    }}
  >
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="21" r="1" />
      <circle cx="20" cy="21" r="1" />
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
    </svg>
    {label || "Buy Now"}
  </a>
);

function DomainTable({ domains, showDetails, currency, section, isAuction, bidCounts, livePrices, onBidClick, onPurchaseClick, setMessageDomain, useDecayPrice }) {

  if (domains.length === 0) {
    return (
      <div style={{ padding: "48px 0", textAlign: "center", color: "#555", fontSize: "15px", letterSpacing: "0.05em" }}>
        Coming soon
      </div>
    );
  }

  return (
    <table className="dynadot-table" style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
      <colgroup>
        <col style={{ width: showDetails ? "32%" : "40%" }} />
        <col style={{ width: showDetails ? "22%" : "30%" }} />
        <col style={{ width: showDetails ? "18%" : "30%" }} />
        {showDetails && <col style={{ width: "28%" }} />}
      </colgroup>
      <thead>
        <tr style={{ borderBottom: "1px solid rgba(31,226,165,0.15)" }}>
          <th style={thStyle}>Domain</th>
          <th style={thStyle}>{isAuction ? "Starting Price" : "Price"}</th>
          <th style={{ ...thStyle, textAlign: "center" }}></th>
          {showDetails && <th style={thStyle}>Details</th>}
        </tr>
      </thead>
      <tbody>
        {domains.map((item, idx) => {
          const isFixed = item.type === "fixed";
          const isLocked = !!item.lockedPrice;
          const itemPrice = getCurrentPrice(item.batch);
          const liveData = livePrices && livePrices[item.domain.toLowerCase()];
          const price = useDecayPrice ? getDecayPrice(item.price) : (liveData ? liveData.price : (isFixed ? item.price : (isLocked ? Math.max(item.lockedPrice, itemPrice) : (item.type === "auction" ? item.price : itemPrice))));
          const schedule = item.batch && PRICE_SCHEDULES[item.batch];
          const atScheduleBottom = schedule && itemPrice === schedule.prices[schedule.prices.length - 1];
          const showLockedBadge = item.bottomReached || (isLocked && itemPrice < item.lockedPrice) || (!isFixed && !isLocked && atScheduleBottom);
          const displayCurrency = item.currency || item.currencyOverride || currency;
          const locale = (displayCurrency === "US$" || displayCurrency === "$") ? "en-US" : displayCurrency === "\u00a3" ? "en-GB" : "de-DE";
          const sym = displayCurrency === "€" ? "€" : displayCurrency === "£" ? "£" : "$";
          const loc = displayCurrency === "€" ? "de-DE" : displayCurrency === "£" ? "en-GB" : "en-US";
          const label = item.labelOverride || (item.makeOffer ? "Private Offer" : (item.type === "auction" ? `from ${sym}${price.toLocaleString(loc)}` : `${sym}${price.toLocaleString(loc)}`));
          const linkUrl = item.url || (item.type === "auction" ? `https://www.dynadot.com/market/user-auction/${item.domain.toLowerCase()}` : `https://forsale.dynadot.com/${item.domain.toLowerCase()}`);
          const handleClick = () => logClick(item.domain, linkUrl, section);
          const isEven = idx % 2 === 0;
          return (
            <tr
              key={item.domain}
              style={{
                backgroundColor: isEven ? "rgba(255,255,255,0.02)" : "transparent",
                borderBottom: "1px solid rgba(255,255,255,0.04)",
                transition: "background-color 0.15s ease",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "rgba(31,226,165,0.05)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = isEven ? "rgba(255,255,255,0.02)" : "transparent"; }}
            >
              <td style={{ padding: "18px 32px", textAlign: "left" }}>
                <a
                  href={linkUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleClick}
                  style={{
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: "1.05rem",
                    letterSpacing: "0.02em",
                    textDecoration: "none",
                    transition: "color 0.15s ease",
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = "#1FE2A5"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = "#fff"; }}
                >
                  {item.displayName || item.domain}
                </a>
                {item.isIDN && (
                  <span style={{
                    display: "inline-block",
                    marginLeft: "8px",
                    padding: "2px 7px",
                    borderRadius: "4px",
                    background: "rgba(31,226,165,0.15)",
                    border: "1px solid rgba(31,226,165,0.3)",
                    color: "#1FE2A5",
                    fontSize: "10px",
                    fontWeight: 700,
                    letterSpacing: "0.06em",
                    verticalAlign: "middle",
                  }}>IDN</span>
                )}
              </td>
              <td style={{ padding: "18px 32px", textAlign: "left" }}>
                <span style={{ display: "inline-flex", alignItems: "center", gap: "12px" }}>
                  <span style={{ color: item.sold ? "#ef4444" : "rgba(255,255,255,0.85)", fontSize: "1rem", fontWeight: item.sold ? 700 : 500 }}>
                    {label}
                  </span>
                  {showLockedBadge && <BottomReachedBadge />}
                </span>
              </td>
              <td style={{ padding: "18px 32px", textAlign: "center" }}>
                {item.sold ? (
                  <span style={{
                    display: "inline-flex", alignItems: "center", gap: "6px", padding: "8px 24px",
                    borderRadius: "50px", background: "rgba(239,68,68,0.15)", border: "1px solid rgba(239,68,68,0.3)",
                    color: "#ef4444", fontWeight: 700, fontSize: "13px", letterSpacing: "0.05em", textTransform: "uppercase",
                  }}>SOLD</span>
                ) : item.localPurchase ? (
                  <button
                    onClick={() => onPurchaseClick && onPurchaseClick(item.domain, price)}
                    className="dynadot-buy-btn"
                    style={{
                      display: "inline-flex", alignItems: "center", gap: "8px", padding: "10px 28px",
                      borderRadius: "50px", background: "linear-gradient(135deg, #1FE2A5 0%, #14b882 50%, #0fa36e 100%)",
                      color: "#000", fontWeight: 700, fontSize: "13px", letterSpacing: "0.05em", textTransform: "uppercase",
                      border: "none", cursor: "pointer",
                      boxShadow: "0 2px 12px rgba(31,226,165,0.25), inset 0 1px 0 rgba(255,255,255,0.2)",
                      transition: "all 0.2s ease",
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = "0 6px 24px rgba(31,226,165,0.4)"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 2px 12px rgba(31,226,165,0.25)"; }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" />
                      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                    </svg>
                    Buy Now
                  </button>
                ) : item.makeOffer ? (
                  <button
                    onClick={() => onBidClick && onBidClick(item.domain, item.minBid || 20)}
                    className="dynadot-buy-btn"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "10px 28px",
                      borderRadius: "50px",
                      background: "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)",
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: "13px",
                      letterSpacing: "0.05em",
                      textTransform: "uppercase",
                      border: "none",
                      cursor: "pointer",
                      boxShadow: "0 2px 12px rgba(139,92,246,0.35), inset 0 1px 0 rgba(255,255,255,0.2)",
                      transition: "all 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-1px)";
                      e.currentTarget.style.boxShadow = "0 6px 24px rgba(139,92,246,0.5), inset 0 1px 0 rgba(255,255,255,0.2)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 2px 12px rgba(139,92,246,0.35), inset 0 1px 0 rgba(255,255,255,0.2)";
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                    </svg>
                    Make Offer
                  </button>
                ) : item.pendingSale ? (
                  <span style={{ display: "inline-flex", alignItems: "center", gap: "8px", flexWrap: "wrap", justifyContent: "center" }}>
                    <span style={{
                      display: "inline-flex", alignItems: "center", gap: "5px", padding: "5px 14px",
                      borderRadius: "50px", background: "rgba(59,130,246,0.15)", border: "1px solid rgba(59,130,246,0.3)",
                      color: "#3b82f6", fontWeight: 600, fontSize: "10px", letterSpacing: "0.05em", textTransform: "uppercase",
                      whiteSpace: "nowrap",
                    }}>
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" />
                      </svg>
                      Pending Sale
                    </span>
                    <button
                      onClick={() => setMessageDomain && setMessageDomain(item.domain)}
                      className="dynadot-buy-btn"
                      style={{
                        display: "inline-flex", alignItems: "center", gap: "8px", padding: "10px 28px",
                        borderRadius: "50px", background: "linear-gradient(135deg, #1FE2A5 0%, #14b882 50%, #0fa36e 100%)",
                        color: "#000", fontWeight: 700, fontSize: "13px", letterSpacing: "0.05em", textTransform: "uppercase",
                        border: "none", cursor: "pointer",
                        boxShadow: "0 2px 12px rgba(31,226,165,0.25), inset 0 1px 0 rgba(255,255,255,0.2)",
                        transition: "all 0.2s ease", whiteSpace: "nowrap",
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = "0 6px 24px rgba(31,226,165,0.4)"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 2px 12px rgba(31,226,165,0.25)"; }}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                      </svg>
                      Message
                    </button>
                  </span>
                ) : isAuction ? (
                  <BuyNowButton href={linkUrl} onClick={handleClick} label="Bid Now" />
                ) : item.payWith === "both" ? (
                  <span style={{ display: "inline-flex", alignItems: "center", gap: "10px", flexWrap: "wrap", justifyContent: "center" }}>
                    <BuyNowButton href={linkUrl} onClick={handleClick} />
                    <a
                      href={item.godaddyUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => logClick(item.domain, item.godaddyUrl, section)}
                      className="dynadot-buy-btn"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "10px 24px",
                        borderRadius: "50px",
                        background: "linear-gradient(135deg, #00a4a6 0%, #007b7d 100%)",
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "13px",
                        letterSpacing: "0.03em",
                        textDecoration: "none",
                        boxShadow: "0 2px 12px rgba(0,164,166,0.3)",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-1px)";
                        e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,164,166,0.45)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,164,166,0.3)";
                      }}
                    >
                      Pay with
                      <img src={godaddyIcon} alt="GoDaddy" style={{ height: "22px", filter: "brightness(0) invert(1)" }} />
                    </a>
                  </span>
                ) : item.payWith === "godaddy" ? (
                  <a
                    href={linkUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleClick}
                    className="dynadot-buy-btn"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "10px 24px",
                      borderRadius: "50px",
                      background: "linear-gradient(135deg, #00a4a6 0%, #007b7d 100%)",
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: "13px",
                      letterSpacing: "0.03em",
                      textDecoration: "none",
                      boxShadow: "0 2px 12px rgba(0,164,166,0.3)",
                      transition: "all 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-1px)";
                      e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,164,166,0.45)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,164,166,0.3)";
                    }}
                  >
                    Pay with
                    <img src={godaddyIcon} alt="GoDaddy" style={{ height: "22px", filter: "brightness(0) invert(1)" }} />
                  </a>
                ) : (
                  <BuyNowButton href={linkUrl} onClick={handleClick} />
                )}
              </td>
              {showDetails && (
                <td style={{ padding: "18px 32px", textAlign: "left", color: "rgba(255,255,255,0.65)", fontSize: "0.85rem", letterSpacing: "0.01em" }}>
                  {item.details}
                </td>
              )}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

const thStyle = {
  textAlign: "left",
  padding: "14px 32px",
  color: "#1FE2A5",
  fontSize: "11px",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.15em",
};

// ── This Week — Main (€218 each) ──
const domains218 = [
  { domain: "Actionminds.com", details: "registered 2015, GoDaddy Value: $1,615", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Awesomesingles.com", details: "registered 2002, GoDaddy Value: $1,650", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Beijingschool.com", details: "registered 2024, DotDB: 3, Estibot: $1,100", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Briss.eu", details: "registered 2023, DotDB: 29", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Caratsuperstore.com", details: "registered 2000, GoDaddy Value: $1,285", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Financialconsulting.eu", details: "registered 2019, DotDB: 40", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Fintechacademy.eu", details: "registered 2019, DotDB: 33", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Hexhacker.com", details: "registered 2005", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Inufu.com", details: "registered 2016, GoDaddy Value: $1,475", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Londongardeners.com", details: "registered 2001, DotDB: 3, GoDaddy Value: $2,149", type: "fixed", price: 218, localPurchase: true, currency: "€" },
];

// ── (No NDD .FR this week) ──
const frenchOverseasDomains218 = [];

// ── This Week — DE/AT/CH Specials (€218) ──
const deAtChLiDomains218 = [
  { domain: "3793.de", details: "registered 2024, DotDB: 16, GoDaddy Value: $3,209", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "624.ch", details: "registered 2006, DotDB: 57", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Betafreundin.de", details: "registered 2024", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Bluff.at", details: "registered 2025, DotDB: 138", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Chubby.ch", details: "registered 2006, DotDB: 124, Estibot: $5,200", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Comingsoon.ch", details: "registered 2000, DotDB: 135, Estibot: $2,000", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Cute.li", details: "registered 2002, DotDB: 290, GoDaddy Value: $1,473", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Digitruck.de", details: "registered 2021, DotDB: 12, GoDaddy Value: $2,064", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Dreamlights.de", details: "registered 2020, DotDB: 35, GoDaddy Value: $3,019", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Grunge.at", details: "DotDB: 65", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Learnchinese.de", details: "registered 2022, DotDB: 53, GoDaddy Value: $3,093", type: "fixed", price: 218, localPurchase: true, currency: "€" },
  { domain: "Plasmalab.de", details: "registered 2019, DotDB: 16", type: "fixed", price: 218, localPurchase: true, currency: "€" },
];

// ── This Week — Acorn Domains .UK Special (£218) ──
const ukDomains218 = [
  { domain: "Barth.uk", details: "registered 2026, DotDB: 124", type: "fixed", price: 218, localPurchase: true, currency: "£" },
  { domain: "Beverlyhills.uk", details: "registered 2026, DotDB: 158, Estibot: $1,100", type: "fixed", price: 218, localPurchase: true, currency: "£" },
  { domain: "Cohabitation.uk", details: "registered 2026, DotDB: 22", type: "fixed", price: 218, localPurchase: true, currency: "£" },
  { domain: "Cruiseport.uk", details: "registered 2026, DotDB: 16", type: "fixed", price: 218, localPurchase: true, currency: "£" },
  { domain: "Fock.uk", details: "registered 2026, DotDB: 47", type: "fixed", price: 218, localPurchase: true, currency: "£" },
  { domain: "Ileach.uk", details: "registered 2025, DotDB: 7", type: "fixed", price: 218, localPurchase: true, currency: "£" },
  { domain: "Julietta.uk", details: "registered 2026, DotDB: 43, Estibot: $1,000", type: "fixed", price: 218, localPurchase: true, currency: "£" },
  { domain: "Mire.uk", details: "registered 2020, DotDB: 83, Dynadot: $8,559", type: "fixed", price: 218, localPurchase: true, currency: "£" },
  { domain: "Polynesia.uk", details: "registered 2021, DotDB: 42, Estibot: $1,500", type: "fixed", price: 218, localPurchase: true, currency: "£" },
  { domain: "Purposely.uk", details: "registered 2026, DotDB: 46", type: "fixed", price: 218, localPurchase: true, currency: "£" },
];

// ── Past Week — €398 Each ──
const domains398 = [
  { domain: "PJF.cc", details: "registered 2005, DotDB: 62", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "OOU.co", details: "registered 2014, DotDB: 65, Estibot: $1,300", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "UGHX.com", details: "registered 2012, DotDB: 3, Estibot: $4,000", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "BeautifulDevelopment.com", details: "GoDaddy Value: $1,686", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "EurasianGrill.com", details: "registered 1999", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "FunnyHalloween.com", details: "registered 2003, GoDaddy Value: $2,198", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "GreekTravelAgents.com", details: "registered 2004", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "KettleBuddy.com", details: "registered 2021", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "RadioBonn.com", details: "registered 2001, DotDB: 3, Estibot: $1,000", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "CXM.ch", details: "registered 2019, DotDB: 113, Estibot: $5,200", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Christian.yt", details: "registered 2021, DotDB: 356, GoDaddy Value: $1,048", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Etc.yt", details: "registered 2021, DotDB: 336, GoDaddy Value: $3,020", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Holidays.yt", details: "registered 2021, DotDB: 239", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Men.yt", details: "registered 2021, DotDB: 275, GoDaddy Value: $1,683", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Prestige.re", details: "registered 2021, DotDB: 402, GoDaddy Value: $1,855", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Raw.yt", details: "registered 2021, DotDB: 313, GoDaddy Value: $3,109", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Token.yt", details: "registered 2017, DotDB: 524, GoDaddy Value: $3,622", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Tokens.yt", details: "registered 2017, DotDB: 309, GoDaddy Value: $2,222", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Ether.pm", details: "registered 2021, DotDB: 352, GoDaddy Value: $1,795", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Ether.tf", details: "registered 2021, DotDB: 352, GoDaddy Value: $1,795", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "178.ch", details: "registered 2003, DotDB: 125, Estibot: $1,700", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "JGD.ch", details: "registered 2018, DotDB: 69", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Johannis.ch", details: "registered 2003, DotDB: 14", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "NCJ.ch", details: "registered 2018, DotDB: 65", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "PDY.ch", details: "registered 2007, DotDB: 57", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "PhoneNumbers.ch", details: "registered 2008, DotDB: 77, Estibot: $1,600", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "PowerSaver.ch", details: "registered 2008, DotDB: 45", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "SalesProfi.ch", details: "registered 2005, DotDB: 8", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Schul.ch", details: "registered 2004, DotDB: 61", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "VFQ.ch", details: "registered 2013, DotDB: 32", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Boone.uk", details: "registered 2025, DotDB: 94, Estibot: $1,200", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Buena.uk", details: "registered 2025, DotDB: 68", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Bunga.uk", details: "registered 2021, DotDB: 61", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Carioca.uk", details: "registered 2021, DotDB: 86", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Coli.uk", details: "registered 2025, DotDB: 72, Estibot: $1,700", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Domingo.uk", details: "registered 2025, DotDB: 108, Estibot: $1,200", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Doon.uk", details: "registered 2025, DotDB: 74", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Fief.uk", details: "registered 2023, DotDB: 35, Estibot: $1,000", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Multitool.uk", details: "registered 2025, DotDB: 78, Estibot: $1,900", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Platin.uk", details: "registered 2025, DotDB: 95, Estibot: $1,600", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Sybil.uk", details: "registered 2025, DotDB: 78, Estibot: $1,100", type: "fixed", price: 398, localPurchase: true, currency: "€" },
  { domain: "Vanya.uk", details: "registered 2025, DotDB: 81", type: "fixed", price: 398, localPurchase: true, currency: "€" },
];

// ── 1999 Domains ($1,999 each) ──
const domains1999 = [
  { domain: "QLV.si", details: "SI = Super Intelligence, the hottest extension right now!", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Swags.eu", details: "registered 2018, DotDB: 43, Dynadot: $1,516", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Thoughts.eu", details: "registered 2019, DotDB: 155, GoDaddy Value: $4,493", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Stan.li", details: "registered 2006, DotDB: 277", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Sue.li", details: "registered 2001, DotDB: 150, Estibot: $2,200", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Matrimony.eu", details: "registered 2019, DotDB: 84, Dynadot: $3,204", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Disclosure.eu", details: "registered 2019, DotDB: 99, Dynadot: $2,742", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Angles.ch", details: "registered 2006, DotDB: 88, Dynadot: $8,244", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Gunshop.eu", details: "registered 2021, DotDB: 65, Dynadot: $1,709", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Raves.eu", details: "registered 2018, DotDB: 58, Dynadot: $1,983", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Widgets.at", details: "registered 2015, DotDB: 93", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "ZVJ.ch", details: "registered 2008, DotDB: 32, Estibot: $1,500", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "588.ch", details: "registered 2004, DotDB: 156, Estibot: $1,700", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Arthur.ch", details: "registered 1998, DotDB: 233, Estibot: $1,500", sold: true, labelOverride: "SOLD", currency: "US$" },
  { domain: "FUJ.ch", details: "registered 2019, DotDB: 53, Estibot: $5,200", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Syndicus.ch", details: "registered 2021, DotDB: 30", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "GPTs.at", details: "registered 2023, DotDB: 185, Dynadot: $5,110", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Hate.ch", details: "registered 1999, DotDB: 163, Estibot: $5,200", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Lina.uk", details: "registered 2019, DotDB: 201, Estibot: $1,200", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Cornelia.uk", details: "registered 2025, DotDB: 87, Estibot: $1,000", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Dreamgirl.uk", details: "registered 2025, DotDB: 64", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Kraut.uk", details: "registered 2025, DotDB: 103", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Privateer.uk", details: "registered 2025, DotDB: 75", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
  { domain: "Turks.uk", details: "registered 2025, DotDB: 63, Estibot: $26,000", type: "fixed", price: 1999, localPurchase: true, currency: "US$" },
];

const DynadotAuctions = () => {
  const hostname = window.location.hostname;
  const is218 = hostname.includes("218domains") || hostname.includes("218d");
  const is398 = hostname.includes("398");

  const [showDetails, setShowDetails] = useState(true);
  const [bidDomain, setBidDomain] = useState(null);
  const [bidMinBid, setBidMinBid] = useState(20);
  const [purchaseDomain, setPurchaseDomain] = useState(null);
  const [purchasePrice, setPurchasePrice] = useState(0);
  const [purchaseCurrency, setPurchaseCurrency] = useState("$");
  const [messageDomain, setMessageDomain] = useState(null);
  const [bidCurrency, setBidCurrency] = useState("$");
  const [bidCounts, setBidCounts] = useState({});
  const [livePrices, setLivePrices] = useState({});
  const currentPrice = getCurrentPrice("batch8");
  const nextChangeDate = getNextPriceChangeDate("batch8");

  const fetchBidCounts = () => {
    fetch(`${apiBaseUrl}/api/bid-counts`).then(r => r.json()).then(setBidCounts).catch(() => {});
  };
  const fetchLivePrices = () => {
    fetch(`${apiBaseUrl}/api/dynadot-prices`).then(r => r.json()).then(data => {
      const map = {};
      (data.auctions || []).forEach(a => {
        if (!a.error && a.bid_price_usd) {
          map[a.domain.toLowerCase()] = { price: a.bid_price_usd, end_time: a.end_time_str };
        }
      });
      setLivePrices(map);
    }).catch(() => {});
  };
  useEffect(() => { fetchBidCounts(); fetchLivePrices(); }, []);

  const font = "'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif";

  return (
    <div style={{ width: "100%", margin: "0 auto", padding: "16px 0 0", fontFamily: font }}>
      <style>{`
        @media (max-width: 768px) {
          .dynadot-table td, .dynadot-table th { padding: 10px 12px !important; }
          .dynadot-table td a[style], .dynadot-table td span[style] { font-size: 0.85rem !important; }
          .dynadot-buy-btn { padding: 7px 14px !important; font-size: 11px !important; gap: 4px !important; }
          .dynadot-buy-btn svg { width: 12px !important; height: 12px !important; }
          .dynadot-bottom-badge { padding: 3px 8px !important; font-size: 9px !important; }
          .dynadot-table { table-layout: auto !important; min-width: 600px; }
          .dynadot-table-wrap { overflow-x: auto !important; -webkit-overflow-scrolling: touch; }
        }
      `}</style>

      {/* ── Hero header ── */}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <h2 style={{
          fontSize: "2rem",
          fontWeight: 800,
          color: "#fff",
          margin: "0 0 6px",
          letterSpacing: "-0.02em",
          lineHeight: 1.2,
          fontFamily: font,
        }}>
          {is398 ? "Domain Auctions" : "218 Domains"}
        </h2>
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
          marginBottom: "4px",
        }}>
          <span style={{ color: "rgba(255,255,255,0.45)", fontSize: "1.05rem", fontWeight: 500, fontFamily: font }}>
            in partnership with
          </span>
          <img src={godaddyIcon} alt="GoDaddy" style={{ height: "24px", filter: "brightness(0) invert(1)", verticalAlign: "middle" }} />
        </div>
      </div>

      {/* ── 218 / aucdom layout (default) ── */}
      {!is398 ? (
        <div style={{ maxWidth: "1340px", margin: "0 auto", padding: "0 24px" }}>
          {/* Nav tabs */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", marginBottom: "20px", flexWrap: "wrap" }}>
            {[
              { label: "Main", anchor: "#218-main" },
              { label: "Acorn .UK", anchor: "#218-uk" },
              { label: "DE/AT/CH", anchor: "#218-dach" },
              { label: "Past Week €398", anchor: "#218-398" },
              { label: "1999 Domains", anchor: "#218-1999" },
            ].map((section) => (
              <a key={section.anchor} href={section.anchor} style={{
                padding: "8px 20px", borderRadius: "50px", border: "1px solid rgba(31,226,165,0.3)",
                color: "#1FE2A5", fontWeight: 600, fontSize: "13px", letterSpacing: "0.04em",
                textDecoration: "none", transition: "all 0.2s ease", fontFamily: font,
              }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#1FE2A5"; e.currentTarget.style.color = "#000"; e.currentTarget.style.borderColor = "#1FE2A5"; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; e.currentTarget.style.color = "#1FE2A5"; e.currentTarget.style.borderColor = "rgba(31,226,165,0.3)"; }}
              >{section.label}</a>
            ))}
            <span style={{ width: "1px", height: "24px", backgroundColor: "rgba(255,255,255,0.1)", margin: "0 8px" }} />
            <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", userSelect: "none" }}>
              <span style={{ color: "rgba(255,255,255,0.5)", fontSize: "13px", fontWeight: 500, fontFamily: font }}>Details</span>
              <div onClick={() => setShowDetails(!showDetails)} style={{ width: "40px", height: "22px", borderRadius: "11px", backgroundColor: showDetails ? "#1FE2A5" : "#2a2a2a", position: "relative", transition: "background-color 0.2s ease", cursor: "pointer" }}>
                <div style={{ width: "18px", height: "18px", borderRadius: "50%", backgroundColor: "#fff", position: "absolute", top: "2px", left: showDetails ? "20px" : "2px", transition: "left 0.2s ease", boxShadow: "0 1px 3px rgba(0,0,0,0.3)" }} />
              </div>
            </label>
          </div>

          {/* Main section */}
          <div id="218-main" style={{ marginBottom: "56px" }}>
            <h3 style={{ fontSize: "1.15rem", fontWeight: 700, color: "#fff", marginBottom: "8px", display: "flex", alignItems: "center", gap: "12px", fontFamily: font }}>
              <span style={{ width: "3px", height: "20px", borderRadius: "2px", background: "#1FE2A5", display: "inline-block" }} />
              Handpicked Domains — €218 Each
            </h3>
            <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.85rem", marginBottom: "14px", fontFamily: font }}>
              Handpicked domains each just €218 Buy Now or €218 min bid (no reserve), depending on the listing.
            </p>
            <div className="dynadot-table-wrap" style={{ borderRadius: "16px", overflow: "hidden", border: "1px solid rgba(255,255,255,0.06)", background: "rgba(255,255,255,0.015)" }}>
              <DomainTable domains={domains218} showDetails={showDetails} currency="€" section="218 Main" onBidClick={(d, min) => { setBidDomain(d); setBidMinBid(min || 218); setBidCurrency("€"); }} onPurchaseClick={(d, p) => { setPurchaseDomain(d); setPurchasePrice(p); setPurchaseCurrency("€"); }} setMessageDomain={setMessageDomain} />
            </div>
            <p style={{ color: "rgba(255,255,255,0.35)", fontSize: "0.8rem", marginTop: "10px", textAlign: "center", fontFamily: font }}>218d.com / 218domains.com / info@aucdom.com</p>
          </div>

          {/* Subscribe box */}
          <div style={{
            marginBottom: "56px", padding: "24px 28px", borderRadius: "16px",
            border: "1px solid rgba(31,226,165,0.2)", background: "rgba(31,226,165,0.04)", textAlign: "center",
          }}>
            <p style={{ color: "#fff", fontSize: "0.95rem", fontWeight: 600, margin: "0 0 6px", fontFamily: font }}>
              Subscribe for weekly domain offers to your inbox.
            </p>
            <form onSubmit={(e) => {
              e.preventDefault();
              const email = e.target.subEmail.value;
              if (!email) return;
              fetch(`${apiBaseUrl}/subscribe`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email, list: "aucdom" }) })
                .then(() => { e.target.subEmail.value = ""; e.target.closest("div").querySelector(".sub-msg").textContent = "Subscribed!"; });
            }} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px", marginTop: "12px" }}>
              <input name="subEmail" type="email" placeholder="Your email" required style={{
                background: "#111", border: "1px solid #333", borderRadius: "12px", padding: "10px 16px",
                color: "#fff", fontSize: "14px", outline: "none", width: "100%", maxWidth: "340px",
              }} />
              <button type="submit" style={{
                padding: "10px 32px", borderRadius: "50px",
                background: "linear-gradient(135deg, #1FE2A5 0%, #14b882 100%)",
                color: "#000", fontWeight: 700, fontSize: "13px", letterSpacing: "0.05em",
                textTransform: "uppercase", border: "none", cursor: "pointer",
                boxShadow: "0 2px 12px rgba(31,226,165,0.25)",
              }}>Subscribe</button>
              <span className="sub-msg" style={{ color: "#1FE2A5", fontSize: "13px", minHeight: "18px" }}></span>
            </form>
          </div>

          {/* DE/AT/CH/LI */}
          <div id="218-dach" style={{ marginBottom: "56px" }}>
            <h3 style={{ fontSize: "1.15rem", fontWeight: 700, color: "#fff", marginBottom: "8px", display: "flex", alignItems: "center", gap: "12px", fontFamily: font }}>
              <span style={{ width: "3px", height: "20px", borderRadius: "2px", background: "#1FE2A5", display: "inline-block" }} />
              DE / AT / CH Specials
            </h3>
            <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.85rem", marginBottom: "14px", fontFamily: font }}>
              Kuratierte Domains — jeweils nur €218 Sofortkauf oder €218 Mindestgebot (ohne Reserve), je nach Angebot.
            </p>
            <div className="dynadot-table-wrap" style={{ borderRadius: "16px", overflow: "hidden", border: "1px solid rgba(255,255,255,0.06)", background: "rgba(255,255,255,0.015)" }}>
              <DomainTable domains={deAtChLiDomains218} showDetails={showDetails} currency="€" section="DE/AT/CH/LI" onBidClick={(d, min) => { setBidDomain(d); setBidMinBid(min || 218); setBidCurrency("€"); }} onPurchaseClick={(d, p) => { setPurchaseDomain(d); setPurchasePrice(p); setPurchaseCurrency("€"); }} setMessageDomain={setMessageDomain} />
            </div>
            <p style={{ color: "rgba(255,255,255,0.35)", fontSize: "0.8rem", marginTop: "10px", textAlign: "center", fontFamily: font }}>218domains.com / info@aucdom.com</p>
          </div>

          {/* UK */}
          <div id="218-uk" style={{ marginBottom: "56px" }}>
            <h3 style={{ fontSize: "1.15rem", fontWeight: 700, color: "#fff", marginBottom: "8px", display: "flex", alignItems: "center", gap: "12px", fontFamily: font }}>
              <span style={{ width: "3px", height: "20px", borderRadius: "2px", background: "#1FE2A5", display: "inline-block" }} />
              Acorn Domains .UK Special — £218 Each
            </h3>
            <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.85rem", marginBottom: "14px", fontFamily: font }}>
              Handpicked domains each just £218 Buy Now or £218 min bid (no reserve), depending on the listing.
            </p>
            <div className="dynadot-table-wrap" style={{ borderRadius: "16px", overflow: "hidden", border: "1px solid rgba(255,255,255,0.06)", background: "rgba(255,255,255,0.015)" }}>
              <DomainTable domains={ukDomains218} showDetails={showDetails} currency="£" section="UK Domains" onBidClick={(d, min) => { setBidDomain(d); setBidMinBid(min || 218); setBidCurrency("£"); }} onPurchaseClick={(d, p) => { setPurchaseDomain(d); setPurchasePrice(p); setPurchaseCurrency("£"); }} setMessageDomain={setMessageDomain} />
            </div>
            <p style={{ color: "rgba(255,255,255,0.35)", fontSize: "0.8rem", marginTop: "10px", textAlign: "center", fontFamily: font }}>218domains.com / info@aucdom.com</p>
          </div>

          {/* Past Week — €398 */}
          <div id="218-398" style={{ marginBottom: "56px" }}>
            <h3 style={{ fontSize: "1.15rem", fontWeight: 700, color: "#fff", marginBottom: "8px", display: "flex", alignItems: "center", gap: "12px", fontFamily: font }}>
              <span style={{ width: "3px", height: "20px", borderRadius: "2px", background: "#f59e0b", display: "inline-block" }} />
              Past Week — €398 Each
            </h3>
            <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.85rem", marginBottom: "14px", fontFamily: font }}>
              Last week's domains at €398 each.
            </p>
            <div className="dynadot-table-wrap" style={{ borderRadius: "16px", overflow: "hidden", border: "1px solid rgba(255,255,255,0.06)", background: "rgba(255,255,255,0.015)" }}>
              <DomainTable domains={domains398} showDetails={showDetails} currency="€" section="Past Week 398" onPurchaseClick={(d, p) => { setPurchaseDomain(d); setPurchasePrice(p); setPurchaseCurrency("€"); }} setMessageDomain={setMessageDomain} />
            </div>
          </div>

          {/* 1999 Domains */}
          <div id="218-1999" style={{ marginBottom: "56px" }}>
            <h3 style={{ fontSize: "1.15rem", fontWeight: 700, color: "#fff", marginBottom: "8px", display: "flex", alignItems: "center", gap: "12px", fontFamily: font }}>
              <span style={{ width: "3px", height: "20px", borderRadius: "2px", background: "#ef4444", display: "inline-block" }} />
              1999 Domains — $1,999 Each
            </h3>
            <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.85rem", marginBottom: "14px", fontFamily: font }}>
              Premium domains at $1,999 each.
            </p>
            <div className="dynadot-table-wrap" style={{ borderRadius: "16px", overflow: "hidden", border: "1px solid rgba(255,255,255,0.06)", background: "rgba(255,255,255,0.015)" }}>
              <DomainTable domains={domains1999} showDetails={showDetails} currency="US$" section="1999 Domains" onPurchaseClick={(d, p) => { setPurchaseDomain(d); setPurchasePrice(p); setPurchaseCurrency("$"); }} setMessageDomain={setMessageDomain} />
            </div>
          </div>

          <p style={{ color: "rgba(255,255,255,0.35)", fontSize: "0.8rem", marginTop: "32px", textAlign: "center", fontFamily: font }}>
            Net prices, excluding transfer/renewal fees where applicable.
          </p>
        </div>
      ) : (
      <>

      {/* ── Section navigation + Show Details toggle ── */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", marginBottom: "20px", flexWrap: "wrap", maxWidth: "1340px", margin: "0 auto 20px", padding: "0 24px" }}>
        {[
          { label: "This Week", anchor: "#dynadot-thisweek", domains: thisWeekDomains },
          { label: "Past Week SI", anchor: "#dynadot-pastweek-si", domains: pastWeekSiDomains },
          { label: "Past Week DE", anchor: "#dynadot-german-si", domains: lastWeekGermanDomains },
          { label: "Past Week", anchor: "#dynadot-lastweek", domains: lastWeekDomains },
        ].filter((s) => s.domains.length > 0).map((section) => (
          <a
            key={section.anchor}
            href={section.anchor}
            style={{
              padding: "8px 20px",
              borderRadius: "50px",
              border: "1px solid rgba(31,226,165,0.3)",
              color: "#1FE2A5",
              fontWeight: 600,
              fontSize: "13px",
              letterSpacing: "0.04em",
              textDecoration: "none",
              transition: "all 0.2s ease",
              fontFamily: font,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#1FE2A5";
              e.currentTarget.style.color = "#000";
              e.currentTarget.style.borderColor = "#1FE2A5";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#1FE2A5";
              e.currentTarget.style.borderColor = "rgba(31,226,165,0.3)";
            }}
          >
            {section.label}
          </a>
        ))}
        <span style={{ width: "1px", height: "24px", backgroundColor: "rgba(255,255,255,0.1)", margin: "0 8px" }} />
        <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", userSelect: "none" }}>
          <span style={{ color: "rgba(255,255,255,0.5)", fontSize: "13px", fontWeight: 500, fontFamily: font }}>Details</span>
          <div
            onClick={() => setShowDetails(!showDetails)}
            style={{
              width: "40px",
              height: "22px",
              borderRadius: "11px",
              backgroundColor: showDetails ? "#1FE2A5" : "#2a2a2a",
              position: "relative",
              transition: "background-color 0.2s ease",
              cursor: "pointer",
            }}
          >
            <div style={{
              width: "18px",
              height: "18px",
              borderRadius: "50%",
              backgroundColor: "#fff",
              position: "absolute",
              top: "2px",
              left: showDetails ? "20px" : "2px",
              transition: "left 0.2s ease",
              boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
            }} />
          </div>
        </label>
      </div>

      {/* ── Tables ── */}
      <div style={{ maxWidth: "1340px", margin: "0 auto", padding: "0 24px" }}>

        {/* This Week — $398 Handpicked Domains */}
        <div id="dynadot-thisweek" style={{ marginBottom: "56px" }}>
          <h3 style={{ fontSize: "1.15rem", fontWeight: 700, color: "#fff", marginBottom: "8px", display: "flex", alignItems: "center", gap: "12px", fontFamily: font }}>
            <span style={{ width: "3px", height: "20px", borderRadius: "2px", background: "#1FE2A5", display: "inline-block" }} />
            This Week — Handpicked Domains
          </h3>
          <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.85rem", marginBottom: "14px", fontFamily: font }}>
            Each just $398 — Buy Now or $398 min bid (no reserve), depending on the listing.
          </p>
          <div className="dynadot-table-wrap" style={{ borderRadius: "16px", overflow: "hidden", border: "1px solid rgba(255,255,255,0.06)", background: "rgba(255,255,255,0.015)" }}>
            <DomainTable domains={thisWeekDomains} showDetails={showDetails} currency="US$" section="This Week" onBidClick={(d, min) => { setBidDomain(d); setBidMinBid(min || 20); }} onPurchaseClick={(d, p) => { setPurchaseDomain(d); setPurchasePrice(p); setPurchaseCurrency("$"); }} setMessageDomain={setMessageDomain} />
          </div>

          {/* Subscribe box */}
          <div style={{
            marginTop: "24px",
            padding: "24px 28px",
            borderRadius: "16px",
            border: "1px solid rgba(31,226,165,0.2)",
            background: "rgba(31,226,165,0.04)",
            textAlign: "center",
          }}>
            <p style={{ color: "#fff", fontSize: "0.95rem", fontWeight: 600, margin: "0 0 6px", fontFamily: font }}>
              Subscribe for weekly domain offers to your inbox.
            </p>
            <form onSubmit={(e) => {
              e.preventDefault();
              const email = e.target.subEmail.value;
              const aucdom = e.target.aucdomList.checked;
              const three98 = e.target.three98List.checked;
              if (!email) return;
              const promises = [];
              if (aucdom) promises.push(fetch(`${apiBaseUrl}/subscribe`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email, list: "aucdom" }) }));
              if (three98) promises.push(fetch(`${apiBaseUrl}/subscribe-398`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email, list: "398" }) }));
              Promise.all(promises).then(() => { e.target.subEmail.value = ""; e.target.closest("div").querySelector(".sub-msg").textContent = "Subscribed!"; });
            }} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px", marginTop: "12px" }}>
              <input name="subEmail" type="email" placeholder="Your email" required style={{
                background: "#111", border: "1px solid #333", borderRadius: "12px", padding: "10px 16px",
                color: "#fff", fontSize: "14px", outline: "none", width: "100%", maxWidth: "340px",
              }} />
              <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                <label style={{ display: "flex", alignItems: "center", gap: "6px", color: "rgba(255,255,255,0.7)", fontSize: "13px", cursor: "pointer" }}>
                  <input name="aucdomList" type="checkbox" defaultChecked style={{ accentColor: "#1FE2A5" }} /> aucdom.com
                </label>
                <label style={{ display: "flex", alignItems: "center", gap: "6px", color: "rgba(255,255,255,0.7)", fontSize: "13px", cursor: "pointer" }}>
                  <input name="three98List" type="checkbox" defaultChecked style={{ accentColor: "#1FE2A5" }} /> 398.domains
                </label>
              </div>
              <button type="submit" style={{
                padding: "10px 32px", borderRadius: "50px",
                background: "linear-gradient(135deg, #1FE2A5 0%, #14b882 100%)",
                color: "#000", fontWeight: 700, fontSize: "13px", letterSpacing: "0.05em",
                textTransform: "uppercase", border: "none", cursor: "pointer",
                boxShadow: "0 2px 12px rgba(31,226,165,0.25)",
              }}>Subscribe</button>
              <span className="sub-msg" style={{ color: "#1FE2A5", fontSize: "13px", minHeight: "18px" }}></span>
            </form>
          </div>
        </div>

        {/* Past Week — SI Domains */}
        {pastWeekSiDomains.length > 0 && (
        <div id="dynadot-pastweek-si" style={{ marginBottom: "56px" }}>
          <h3 style={{ fontSize: "1.15rem", fontWeight: 700, color: "#fff", marginBottom: "8px", display: "flex", alignItems: "center", gap: "12px", fontFamily: font }}>
            <span style={{ width: "3px", height: "20px", borderRadius: "2px", background: "#1FE2A5", display: "inline-block" }} />
            Past Week — Super Intelligence SI
          </h3>
          <div className="dynadot-table-wrap" style={{ borderRadius: "16px", overflow: "hidden", border: "1px solid rgba(255,255,255,0.06)", background: "rgba(255,255,255,0.015)" }}>
            <DomainTable domains={pastWeekSiDomains} showDetails={showDetails} currency="US$" section="Past Week SI" onBidClick={(d, min) => { setBidDomain(d); setBidMinBid(min || 20); }} setMessageDomain={setMessageDomain} />
          </div>
          <p style={{ color: "rgba(245,158,11,0.8)", fontSize: "0.85rem", marginTop: "12px", fontFamily: font, textAlign: "center" }}>
            Domains will be removed from this list soon.
          </p>
        </div>
        )}

        {/* Past Week — Deutsche SI Domains */}
        {lastWeekGermanDomains.length > 0 && (
        <div id="dynadot-german-si" style={{ marginBottom: "56px" }}>
          <h3 style={{ fontSize: "1.15rem", fontWeight: 700, color: "#fff", marginBottom: "8px", display: "flex", alignItems: "center", gap: "12px", fontFamily: font }}>
            <span style={{ width: "3px", height: "20px", borderRadius: "2px", background: "#1FE2A5", display: "inline-block" }} />
            Past Week — Deutsche Domains SI
          </h3>
          <div className="dynadot-table-wrap" style={{ borderRadius: "16px", overflow: "hidden", border: "1px solid rgba(255,255,255,0.06)", background: "rgba(255,255,255,0.015)" }}>
            <DomainTable domains={lastWeekGermanDomains} showDetails={showDetails} currency="US$" section="Past Week DE" onBidClick={(d, min) => { setBidDomain(d); setBidMinBid(min || 20); }} setMessageDomain={setMessageDomain} />
          </div>
          <p style={{ color: "rgba(245,158,11,0.8)", fontSize: "0.85rem", marginTop: "12px", fontFamily: font, textAlign: "center" }}>
            Domains will be removed from this list soon.
          </p>
        </div>
        )}

        {/* Past Week — Private Offers */}
        {lastWeekDomains.length > 0 && (
        <div id="dynadot-lastweek" style={{ marginBottom: "56px" }}>
          <h3 style={{ fontSize: "1.15rem", fontWeight: 700, color: "#fff", marginBottom: "8px", display: "flex", alignItems: "center", gap: "12px", fontFamily: font }}>
            <span style={{ width: "3px", height: "20px", borderRadius: "2px", background: "#1FE2A5", display: "inline-block" }} />
            Past Week — Private Offers
          </h3>
          <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.85rem", marginBottom: "14px", fontFamily: font }}>
            Make an offer for any domain. Minimum offer: $20. All offers are private.
          </p>
          <div className="dynadot-table-wrap" style={{ borderRadius: "16px", overflow: "hidden", border: "1px solid rgba(255,255,255,0.06)", background: "rgba(255,255,255,0.015)" }}>
            <DomainTable domains={lastWeekDomains} showDetails={showDetails} currency="US$" section="Past Week" onBidClick={(d, min) => { setBidDomain(d); setBidMinBid(min || 20); }} setMessageDomain={setMessageDomain} />
          </div>
          <p style={{ color: "rgba(245,158,11,0.8)", fontSize: "0.85rem", marginTop: "12px", fontFamily: font, textAlign: "center" }}>
            Domains will be removed from this list soon.
          </p>
        </div>
        )}

        <p style={{ color: "rgba(255,255,255,0.35)", fontSize: "0.8rem", marginTop: "32px", textAlign: "center", fontFamily: font }}>
          Net prices, excluding transfer/renewal fees where applicable.
        </p>
      </div>
      </>
      )}
      {messageDomain && (
        <MessageForm
          domain={messageDomain}
          onClose={() => setMessageDomain(null)}
        />
      )}
      {bidDomain && (
        <BidForm
          domain={bidDomain}
          minBid={bidMinBid}
          currency={bidCurrency}
          onClose={() => setBidDomain(null)}
          onBidPlaced={() => fetchBidCounts()}
        />
      )}
      {purchaseDomain && (
        <PurchaseForm
          domain={purchaseDomain}
          price={purchasePrice}
          currency={purchaseCurrency}
          onClose={() => setPurchaseDomain(null)}
        />
      )}
    </div>
  );
};

export default DynadotAuctions;
